<template>
  <b-modal
    v-bind="$props"
    :id="id"
    ok-variant="danger"
    no-close-on-backdrop
    @cancel="resolvePromise(false)"
    @ok="resolvePromise(true)"
  >
    <div>
      <Loader :loading="loading" no-axios>
        <div style="min-height: 200px">
          <div class="text-start" v-if="!loading">
            Anda yakin ingin menghapus pembayaran pembelian ini?<br />
            Menghapus Pembayaran Pembelian ini akan mengakibatkan penghapusan beberapa transaksi lainnya yang terkait.
            Tindakan ini tidak dapat dibatalkan.<br />
            <br /><br />
            <div v-if="model && model.deleteCandidates">
              Detail transaksi yang akan dihapus:
              <ol>
                <li v-if="model.deleteCandidates.purchaseOrderPayments.length">
                  Transaksi pembayaran pembelian nota panen
                  <router-link
                    target="_blank"
                    :key="index"
                    v-for="(payment, index) in model.deleteCandidates.purchaseOrderPayments"
                    :to="`/purchase_payments/${payment}`"
                  >
                    {{ payment }}
                    <span v-if="index < model.deleteCandidates.purchaseOrderPayments.length - 1">,</span>
                  </router-link>
                </li>
                <li v-if="model.deleteCandidates.trips.length > 0">
                  Transaksi armada
                  <router-link
                    target="_blank"
                    :key="index"
                    v-for="(trip, index) in model.deleteCandidates.trips"
                    :to="`/trips/${trip}`"
                  >
                    {{ trip }}<span v-if="index < model.deleteCandidates.trips.length - 1">,</span>
                  </router-link>
                </li>
                <li v-if="model.deleteCandidates.saleOrders.length > 0">
                  Transaksi laporan penjualan
                  <router-link
                    target="_blank"
                    :key="index"
                    v-for="(saleOrder, index) in model.deleteCandidates.saleOrders"
                    :to="`/sale_notes/${saleOrder}`"
                  >
                    {{ saleOrder }}<span v-if="index < model.deleteCandidates.saleOrders.length - 1">,</span>
                  </router-link>
                </li>
                <li v-if="model.deleteCandidates.saleOrderPayments.length > 0">
                  Transaksi penerimaan penjualan
                  <router-link
                    target="_blank"
                    :key="index"
                    v-for="(payment, index) in model.deleteCandidates.saleOrderPayments"
                    :to="`/sale_invoices/${payment}`"
                  >
                    {{ payment }}<span v-if="index < model.deleteCandidates.saleOrderPayments.length - 1">,</span>
                  </router-link>
                </li>
              </ol>
            </div>
            Pastikan Anda telah memeriksa dan memastikan bahwa penghapusan ini adalah tindakan yang benar. Jika Anda
            tidak yakin, harap batalkan tindakan ini.
          </div>
        </div>
      </Loader>
    </div>
    <template #modal-footer="{ ok, cancel, hide }">
      <b-button :disabled="deleting" size="md" variant="outline-dark" @click="cancel()">
        Batal
      </b-button>
      <b-button :disabled="loading || deleting" size="md" variant="danger" @click="resolvePromise(true)">
        <i v-if="deleting" class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
        Hapus
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from "@/components/modals/confirmation-modal.vue";
import Loader from "@/components/widgets/loader.vue";
import Swal from "sweetalert2";

export default {
  components: { Loader },
  extends: ConfirmationModal,
  props: {
    id: { default: "purchase-payment-confirmation-modal" },
    hideHeader: { default: false },
    title: { default: "Konfirmasi Penghapusan Transaksi Pembayaran Pembelian" },
    deleting: { default: false }
  },
  data() {
    return {
      options: {
        message: null
      },
      resolvePromise: null,
      rejectPromise: null,
      model: null,
      loading: false
    };
  },
  methods: {
    fetchModel(payment_id) {
      this.loading = true;
      return this.$axios
        .get(`/payments/${payment_id}`, {
          params: {
            with: [
              "paymentables.paymentable.purchase_items.trip_items.trip.sale_order.payments",
              "paymentables.paymentable.paymentables"
            ].join(",")
          }
        })
        .then(response => {
          const {
            data: { data }
          } = response;
          this.model = {
            ...data
          };
          const saleOrders = [];
          const saleOrderPayments = [];
          const trips = [];
          const purchaseOrders = [];
          const purchaseOrderPayments = [];

          data.paymentables.forEach(paymentable => {
            const purchaseOrder = paymentable.paymentable;
            purchaseOrders.push(purchaseOrder.id);
            purchaseOrder.purchase_items.forEach(purchaseItem => {
              purchaseItem.trip_items.forEach(tripItem => {
                const trip = tripItem.trip;
                trips.push(trip.id);
                trip.sale_order.payments.forEach(payment => {
                  saleOrderPayments.push(payment.id);
                });
                saleOrders.push(trip.sale_order.id);
              });
            });
            purchaseOrder.paymentables.forEach(paymentable => {
              purchaseOrderPayments.push(paymentable.payment_id);
            });
          });

          this.model.deleteCandidates = {
            saleOrders: [...new Set(saleOrders)],
            saleOrderPayments: [...new Set(saleOrderPayments)],
            trips: [...new Set(trips)],
            purchaseOrders: [...new Set(purchaseOrders)],
            purchaseOrderPayments: [...new Set(purchaseOrderPayments)]
          };

          return response;
        })
        .catch(error => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
    show(options) {
      return new Promise((resolve, reject) => {
        this.fetchModel(options.payment_id);
        this.options = options;
        this.$bvModal.show(this.id);

        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    hide() {
      this.$bvModal.hide(this.id);
    },
    deleteSuccessAlert() {
      const deleted = [];
      if (this.model.deleteCandidates.purchaseOrderPayments?.length) {
        deleted.push(
          `<li>Transaksi pembayaran nota panen (${this.model.deleteCandidates.purchaseOrderPayments.join(", ")})</li>`
        );
      }
      if (this.model.deleteCandidates.trips?.length) {
        deleted.push(`<li>Transaksi armada (${this.model.deleteCandidates.trips.join(", ")})</li>`);
      }
      if (this.model.deleteCandidates.saleOrders?.length) {
        deleted.push(`<li>Transaksi laporan penjualan (${this.model.deleteCandidates.saleOrders.join(", ")})</li>`);
      }
      if (this.model.deleteCandidates.saleOrderPayments?.length) {
        deleted.push(
          `<li>Transaksi penerimaan penjualan (${this.model.deleteCandidates.saleOrderPayments.join(", ")})</li>`
        );
      }
      if (this.model.deleteCandidates)
        return Swal.fire({
          title: this.$t("Berhasil") + "!",
          html: `
            <div class="text-start">
              Detail transaksi:
              <ul>            
                ${deleted.join("")} 
              </ul>
              Berhasil dihapus.
            </div>

          `,
          type: "success",
          confirmButtonClass: "btn btn-success btn-fill",
          buttonsStyling: false
        });
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .modal-footer {
    border: none;
  }
}
</style>
